import React from 'react'
import { useRouter } from 'next/router'
import { CommonContext } from '@ssr/context'

function AnalyticsApp() {
  const { isCN, isDev } = React.useContext(CommonContext)
  const router = useRouter()
  const pathname = router.asPath?.split('?')[0] || router.pathname
  const shouldLoadGoogle = pathname !== '/app/slide_verification' && pathname !== '/app/slide-verification'

  return (
    <>
      {shouldLoadGoogle ? (
        <>
          {/* <!-- Google tag (gtag.js) --> */}
          <script async src='https://www.googletagmanager.com/gtag/js?id=G-7TV2BE92TS'></script>
          <script
            dangerouslySetInnerHTML={{
              __html: `window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', 'G-7TV2BE92TS');`,
            }}
          />
          {isCN ? (
            //  <!-- Google Tag Manager (noscript) -->
            <noscript>
              <iframe
                src='https://www.googletagmanager.com/ns.html?id=GTM-PGNNRXL'
                height='0'
                width='0'
                style={{
                  display: 'none',
                  visibility: 'hidden',
                }}
              ></iframe>
            </noscript>
          ) : (
            <noscript>
              <iframe
                src='https://www.googletagmanager.com/ns.html?id=GTM-TWBRN8J'
                height='0'
                width='0'
                style={{
                  display: 'none',
                  visibility: 'hidden',
                }}
              ></iframe>
            </noscript>
            //  <!-- End Google Tag Manager (noscript) -->
          )}
        </>
      ) : null}
      {/* 热力图 */}
      {/* <script
        dangerouslySetInnerHTML={{
          __html: `(function (h, o, t, j, a, r) {
            h.hj = h.hj || function () {
              (h.hj.q = h.hj.q || []).push(arguments)
            };
            h._hjSettings = {
              hjid: 2585739,
              hjsv: 6
            };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script');
            r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
          })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');`,
        }}
      /> */}
      {!isCN && !isDev ? (
        // <!-- Cloudflare Web Analytics -->
        <script defer src='https://static.cloudflareinsights.com/beacon.min.js' data-cf-beacon='{"token": "e97128eaacca41bd93a48bc3eb1b1064"}'></script>
      ) : // <!-- End Cloudflare Web Analytics -->
      null}
    </>
  )
}

export default AnalyticsApp
